<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="50%"
      overlay-opacity="0.96"
    >
      <v-card color="grey lighten-4">
        <div class="text-center" style="padding-top: 25px">
          <h3>PLEASE ENTER PASSWORD</h3>
        </div>
        <v-card-text>
          <v-container class="mt-8">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Password"
                  v-model="myPass"
                  :append-icon="value ? 'visibility' : 'visibility_off'"
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                  @mousedown="clearStatus()"
                  @keydown.enter="checkPassword()"
                  @keydown="checkEntry()"
                ></v-text-field>
                <div
                  style="
                    height: 40px;
                    font-size: 12px;
                    color: red;
                    margin-top: -12px;
                    font-weight: 900;
                  "
                  class="text-center"
                >
                  {{ status }}
                </div>
              </v-col>
              <v-col style="margin-top: -10px">
                <p
                  class="text-center"
                  style="font-size: 12px; font-weight: 700"
                >
                  For access to this content, please contact
                  <a href="mailto: mary.ratliff@illinois.gov"
                    >mary.ratliff@illinois.gov</a
                  >
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="purple darken-1" text @click="exitPage()">
            Exit
          </v-btn>
          <v-btn
            large
            color="purple darken-1"
            @click="checkPassword()"
            style="color: #fff"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  methods: {
    checkEntry() {
      if (this.myPass.length >= 0) {
        this.clearStatus();
      }
    },
    clearStatus() {
      this.status = "";
    },
    checkPassword() {
      if (this.myPass === process.env.VUE_APP_GATE) {
        this.dialog = false;
        this.$store.commit("authenticate");
      } else {
        this.status = "Password incorrect. Please try again.";
        this.myPass = "";
      }

      return;
    },
    exitPage() {
      this.$router.push("/");
      return;
    },
  },
  data() {
    return {
      value: String,
      dialog: true,
      myPass: "",
      status: "",
    };
  },
};
</script>
